export function encodeBackgroundAlias(alias: string): string {
  return /^[A-Za-z0-9_-]+$/.test(alias) ? `#background ${alias}` : `#background-json ${JSON.stringify(alias).replace(/#/g, '\\u0023')}`;
}

export function decodeBackgroundAlias(value: string, command = '#background'): string {
  const token = value.trim();
  return command.toLowerCase() === '#background-json' ? JSON.parse(token) : token;
}
